import React, { Fragment } from 'react';
import { animated, to, SpringValue } from '@react-spring/web';
import icon from '@images/wysiwyg_editor/drop_image_button_icon.svg';

type TProps = {
  location: {
    x: SpringValue<number>;
    width: SpringValue<number>;
    y: SpringValue<number>;
    height: SpringValue<number>;
  };
  showBorder: boolean;
  stackOrder: number;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export default function DropImageButton({
  location,
  showBorder,
  stackOrder,
  onMouseEnter,
  onMouseLeave
}: TProps): React.ReactElement {
  return (
    <animated.button
      style={{
        alignItems: 'center',
        background: '#fbfcfe',
        border: showBorder ? '1px dashed #A5C7E2' : '',
        color: '#87929D',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Assistant, Arial, sans-serif',
        fontSize: '1.4rem',
        fontWeight: 400,
        height: location.height,
        justifyContent: 'center',
        left: location.x,
        lineHeight: '1.5',
        outline: 'none',
        overflow: 'hidden',
        padding: '0.5rem 0.2rem',
        position: 'absolute',
        top: location.y,
        width: location.width,
        zIndex: stackOrder
      }}
      type="button"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Fragment>
        <animated.img
          src={icon as string}
          alt=""
          style={{
            marginBottom: to(
              [location.height, location.width],
              (height, width) => {
                return height * width >= 5000 && height > 125 ? 24 : 0;
              }
            ),
            marginTop: to(
              [location.height, location.width],
              (height, width) => {
                return height * width >= 5000 && height > 125 ? 5 : 0;
              }
            ),
            maxHeight: to([location.height], (height) => height - 4),
            display: to([location.height, location.width], (height, width) => {
              return height * width < 5000 || height > 125 ? 'block' : 'none';
            })
          }}
        />
        <animated.span
          style={{
            margin: '0 5px',
            maxWidth: 110,
            display: to([location.height, location.width], (height, width) => {
              return height * width >= 5000 || height > 125 ? 'block' : 'none';
            })
          }}
        >
          Drop pic from photos tab
        </animated.span>
      </Fragment>
    </animated.button>
  );
}
